import { __decorate } from 'tslib';
import { EventEmitter, Output, Input, Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { UiCButtonModule } from '@wlp/ui-c-button';
import { AngularSvgIconModule } from 'angular-svg-icon';

let UiCRequestCardComponent = class UiCRequestCardComponent {
    constructor() {
        this.btnEvent = new EventEmitter();
        this.disabledRequest = false;
        this.embossCard = true;
    }
    ngOnInit() { }
    requestCard() {
        this.btnEvent.emit();
    }
};
__decorate([
    Output()
], UiCRequestCardComponent.prototype, "btnEvent", void 0);
__decorate([
    Input()
], UiCRequestCardComponent.prototype, "param", void 0);
__decorate([
    Input()
], UiCRequestCardComponent.prototype, "disabledRequest", void 0);
__decorate([
    Input()
], UiCRequestCardComponent.prototype, "embossCard", void 0);
UiCRequestCardComponent = __decorate([
    Component({
        selector: 'ui-c-request-card',
        template: "\n<div class=\"request-card-component\">\n  <div class=\"container justify-content-center d-flex\">\n    <div class=\"col-10\">\n      <ion-img class=\"ionimg\" [src]=\"'assets/images/card-manager/card-request.svg'\">\n      </ion-img>\n    </div>\n  </div>\n  <ion-col size=\"12\" class=\"d-flex justify-content-center\">\n    <ion-text class=\"font-size-16 ion-text-center\" *ngIf=\"embossCard === true\">\n      <p class=\"p-card-request\">\n        {{'CARDS.CARD_MANAGER.REQUEST_CARD_DESCRIPTION' | wlpTranslate: param }}\n      </p>\n    </ion-text>\n    <ion-text class=\"font-size-16 ion-text-center\" *ngIf=\"embossCard === false\">\n      <p class=\"p-card-request\">\n        {{'CARDS.CARD_MANAGER.REQUEST_VIRTUAL_CARD_DESCRIPTION' | wlpTranslate: param }}\n      </p>\n    </ion-text>\n  </ion-col>\n  <div class=\"divButton\">\n    <ion-col size=\"6\">\n      <ui-c-button [disabled]=\"disabledRequest\"  expand=\"block\" (continue)=\"requestCard()\">\n        {{'CARDS.CARD_MANAGER.REQUEST_CARD_BUTTON' | wlpTranslate}}</ui-c-button>\n    </ion-col>\n  </div>\n</div>\n",
        styles: [""]
    })
], UiCRequestCardComponent);

let UiCRequestCardModule = class UiCRequestCardModule {
};
UiCRequestCardModule = __decorate([
    NgModule({
        declarations: [
            UiCRequestCardComponent
        ],
        imports: [
            IonicModule,
            CommonModule,
            UiCButtonModule,
            AngularSvgIconModule.forRoot(),
            UiBsTranslateModule
        ],
        exports: [
            UiCRequestCardComponent
        ]
    })
], UiCRequestCardModule);

/*
 * Public API Surface of ui-c-request-card
 */

/**
 * Generated bundle index. Do not edit.
 */

export { UiCRequestCardComponent, UiCRequestCardModule };
//# sourceMappingURL=wlp-ui-c-request-card.js.map
